/**
 * Fime – Key Benefits section: inline "Download product sheet" form
 * toggle (Template 5b).
 *
 * Clicking the trigger button hides it and shows the form panel in
 * its place (no overlay/backdrop). Clicking the panel's X restores
 * the button.
 */

document.querySelectorAll('[data-inline-form-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
                // Trigger can be a <button> (no default action) or an <a>
                // (e.g. single-env-cta, which still carries its ACF Link
                // field's href/target for other uses) — prevent navigation
                // so clicking it only opens the inline form panel.
                if (trigger.tagName === 'A') {
                        event.preventDefault();
                }

                const panelId = trigger.getAttribute('data-inline-form-trigger');
                const panel = document.getElementById(panelId);
                if (!panel) return;
                trigger.hidden = true;
                panel.hidden = false;
        });
});

document.querySelectorAll('[data-inline-form-close]').forEach(function (closer) {
	closer.addEventListener('click', function () {
		const panel = closer.closest('[id]');
		if (!panel) return;
		const trigger = document.querySelector('[data-inline-form-trigger="' + panel.id + '"]');
		panel.hidden = true;
		if (trigger) trigger.hidden = false;
	});
});
